import React from 'react'
import {Link} from 'react-router-dom'
import logo from '../assets/logo.png'
import menu from '../assets/menu.svg'
import { useState } from 'react'
const Navbar = () => {

  const [showMenu, setShowMenu] = useState(false);

  return (
    <div>
        <ul className='flex font-main justify-center md:justify-center items-center'>
            <button onClick={() => setShowMenu(!showMenu)}><li><img className='hidden w-12 md:flex' src={menu}/></li></button>
            <Link to="/math"><li className='mx-12 md:hidden lg:text-3xl text-5xl'>Math</li></Link>
            <Link to="/english"><li className='mx-12 md:hidden lg:text-3xl text-5xl'>English</li></Link>
            <Link to="/"><li className='mx-12 w-32  lg:w-24 h-auto'><img src={logo} alt="A bookshelf with a sign on it saying The Special Library"/></li></Link>
            <Link to="/misc"><li className='mx-12 md:hidden lg:text-3xl text-5xl'>Misc</li></Link>
            <Link to="/request"><li className='mx-12 md:hidden lg:text-3xl text-5xl'>Request/Add</li></Link>
            
        </ul>

        {
          showMenu && (<ul className='flex-col font-main  md:justify-end items-center'>
           
          <Link to="/math"><li className='my-1 p-4 hover:bg-black hover:text-white lg:text-3xl text-center text-5xl'>Math</li></Link>
          <Link to="/english"><li className='my-1 p-4 hover:bg-black hover:text-white lg:text-3xl text-center text-5xl'>English</li></Link>
          
          <Link to="/misc"><li className='my-1 p-4 hover:bg-black hover:text-white lg:text-3xl text-center text-5xl'>Misc</li></Link>
          <Link to="/request"><li className='my-1 p-4 hover:bg-black hover:text-white lg:text-3xl text-center text-5xl'>Request/Add</li></Link>
          
          
          </ul>)
        }
    </div>
  )
}

export default Navbar